import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription as RxJsSubscription} from 'rxjs';
import {PlateauSearchParams} from '../../plateau-search-params';
import {Plateau} from '../../plateau';
import {Helpers} from '@app/shared';
@Component({
  selector: 'hpf-plateau-list',
  templateUrl: './plateau-list.component.html',
  styleUrls: []
})
export class PlateauListComponent implements OnInit, OnDestroy {
  /** The filters */
  searchParams = new PlateauSearchParams(this.route.snapshot.queryParams);
  /** The search params subscription */
  private paramsSubscription: RxJsSubscription;
  /** Used to open or close filter drawer */
  filtersDrawer = false;
  /** Constructor */
  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location) {
  }
  /** Init */
  ngOnInit() {
    // Update query string when params change
    this.paramsSubscription = this.searchParams.subscribe(() => {
      this.location.replaceState('/plateau', Helpers.toQueryString(this.searchParams.toObject()));
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }
  /** Called when the user select a row in the table */
  onSelect(item: Plateau) {
    this.router.navigateByUrl(`/plateau/${item.getId()}`);
  }
  /** Called when the user click on create */
  onCreate() {
    this.router.navigate(['/plateau/create']);
  }
}
